import {
    all,
    call,
    delay,
    fork,
    put,
    race,
    select,
    take
} from "redux-saga/effects";
import {getApiUrl} from "../../config/helper";
import {getCustomer, getLayout, getLanguage, getScreen, getPlayerName, getSliderOrientation} from "../../selectors";
import {
    ADS_RECEIVED,
    BIKES_RECEIVED,
    BUS_RECEIVED,
    EREIDER_RECEIVED,
    VB_RECEIVED,
    EVENTS_TODAY_RECEIVED,
    EVENTS_RECEIVED,
    ACTIVITIES_RECEIVED,
    RESTAURANT_RECEIVED,
    OPENINGHOURS_RECEIVED,
    FETCH_ERROR,
    IMXPOI_RECEIVED,
    JOBS_RECEIVED,
    METEO_RECEIVED,
    NAVIGATION_UPDATE,
    NEWS_RECEIVED,
    PARKING_RECEIVED,
    POI_HELPERKNAPP_RECEIVED,
    POI_RECEIVED,
    MOBILITY_RECEIVED,
    WHATTODO_RECEIVED,
    POLL_RECEIVED,
    POLL_START,
    POLL_STOP,
    RADAR_RECEIVED,
    RTLNEWS_RECEIVED, RTLSDG_RECEIVED, RTLWEATHER_RECEIVED, SDG_RECEIVED,
    TRAFIC_RECEIVED,
    TRAINS_RECEIVED,
    VIDEOADS_RECEIVED,
    ALERT_RECEIVED,
} from "../actions";

function* watchFetchNews() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {

        let fetchUrl;
        if (customer === "schengen") {
            fetchUrl = "http://localhost:5000/provider/news/schengen/nomedia";
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: NEWS_RECEIVED, json: json });
        }
        else if (customer === "contern") {
            fetchUrl = "http://localhost:5000/provider/news/" + customer + "/nomedia";
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: NEWS_RECEIVED, json: json });
        }
        else{
            const json = yield fetch(
                `${apiUrl}/news?customer=${customer}&language=${language}`
            ).then((response) => response.json());
            yield put({ type: NEWS_RECEIVED, json: json });

        }
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchVideoads() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    const screen = yield select(getScreen);
    const sliderOrientation = yield select(getSliderOrientation);
    let apiUrl = getApiUrl(customer);

    let orientation = "landscape";
    if (sliderOrientation) orientation = sliderOrientation;

    try {
        let fetchUrl;
        if (customer === "rtl") {
            fetchUrl = "/videoads_livearena.json";
        }
        else if (customer === "esch") {
            fetchUrl = "http://localhost:5000/provider/slider/vde/";
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: VIDEOADS_RECEIVED, json: json["medium"] });
        }
        else if (customer === "mamer") {
            fetchUrl = "http://localhost:5000/kiss/sliders/mamer";
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: VIDEOADS_RECEIVED, json: json["medium"] });
        }
        else if (customer === "hesperange") {
            fetchUrl = "http://localhost:5000/kiss/sliders/hesperange";
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: VIDEOADS_RECEIVED, json: json["medium"] });
        }
        else{
            fetchUrl = `${apiUrl}/videoads?orientation=${orientation}&customer=${customer}&language=${language}`;
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: VIDEOADS_RECEIVED, json: json });
        }
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }

}

function* watchFetchMeteo() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/meteo2?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: METEO_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchEventsToday() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        /**
        let fetchUrl;
        if (customer === "contern") {
            fetchUrl = "http://localhost:5000/provider/events/"+customer;
            const json = yield fetch(fetchUrl).then((response) => response.json());
            yield put({ type: EVENTS_RECEIVED, json: json });
        }
        else {
            const json = yield fetch(`${apiUrl}/events?provider=eil&customer=${customer}&language=${language}`).then((response) => response.json());
            yield put({ type: EVENTS_TODAY_RECEIVED, json: json });
        }
        */

        const json = yield fetch(`${apiUrl}/events?provider=eil&customer=${customer}&language=${language}`).then((response) => response.json());
        yield put({ type: EVENTS_TODAY_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchActivities() {
    const customer = yield select(getCustomer);
    // const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/activities?customer=${customer}`
        ).then((response) => response.json());
        yield put({ type: ACTIVITIES_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchOpeningHours() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
       const json = yield fetch(
            `${apiUrl}/openinghours?customer=${customer}&language=${language}`
       ).then((response) => response.json());
        yield put({ type: OPENINGHOURS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchRestaurant() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/restaurant?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: RESTAURANT_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchPoi() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const jsonPoi = yield fetch(
            `${apiUrl}/poi?customer=${customer}&language=${language}`
        ).then((response) => response.json());

        yield put({
            type: POI_RECEIVED,
            json: { ...jsonPoi },
        });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchMobility() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const jsonPoi = yield fetch(
            "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstoplistlegacy/json/NG/456fdffsdihlfahdskvalkv98s65d/200405014/1"
        ).then((response) => response.json());

        yield put({
            type: MOBILITY_RECEIVED,
            json: { ...jsonPoi },
        });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchPoiHelperknapp() {
    const customer = yield select(getCustomer);

    if (customer !== 'helperknapp') return;

    try {
        const jsonPoi = yield fetch(
            'https://sm4rt.online/api/export/forms/4871d790-ca10-4156-a332-b1d8d022d4b6/json'
        ).then((response) => response.json());

        yield put({
            type: POI_HELPERKNAPP_RECEIVED,
            json: jsonPoi ,
        });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchIMXPoi() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const jsonPoi = yield fetch(
            `${apiUrl}/imx?customer=${customer}&language=${language}`,
       //     {
       //         mode: 'cors',
       //         headers: {
       //             "access-control-allow-origin": "*",
       //         }
       //     },
        ).then((response) => response.json());

        yield put({
            type: IMXPOI_RECEIVED,
            json: { ...jsonPoi },
        });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchWhatToDo() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const jsonPoi = yield fetch(
            `${apiUrl}/whattodo?customer=${customer}&language=${language}`
        ).then((response) => response.json());

        yield put({
            type: WHATTODO_RECEIVED,
            json: { ...jsonPoi },
        });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchEreider() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);
    try {
        const json = yield fetch(
            `${apiUrl}/raider?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: NAVIGATION_UPDATE, json: json });
        yield put({ type: EREIDER_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchVB() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);
    try {
        const json = yield fetch(
            `${apiUrl}/vb?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: NAVIGATION_UPDATE, json: json });
        yield put({ type: VB_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchTrafic() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/trafic?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: TRAFIC_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchBikes() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    const playerName = yield select(getPlayerName);
    let apiUrl = getApiUrl(customer);

    let name = '';
    if (playerName)
        name = playerName;

    try {
        const json = yield fetch(
            `${apiUrl}/bikes?customer=${customer}&language=${language}&name=${name}`
        ).then((response) => response.json());
        yield put({ type: BIKES_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchTrains() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/train?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: TRAINS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchBus() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/bus?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: BUS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchJobs() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/jobs?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: JOBS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchPoll() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/voting?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: POLL_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchSDG() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/sdg?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: SDG_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchRadar() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/radar?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: RADAR_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchParking() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/parking?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: PARKING_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchAds() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    const sliderOrientation = yield select(getSliderOrientation);
    let apiUrl = getApiUrl(customer);

    let orientation = "portrait";
    if (sliderOrientation) orientation = sliderOrientation;

    try {
        const json = yield fetch(
            `${apiUrl}/videoads?orientation=${orientation}&customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: ADS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchRTLNews() {
    const language = yield select(getLanguage);

    let lang = language;
    if (lang === 'de') lang = 'lu';

    let baseUrl = 'https://api-gw.rtl.lu/niche-guardian/v1';
    try {
        const json = yield fetch(
            `${baseUrl}/news?limit=10&lang=${lang}`
        ).then((response) => response.json());
        yield put({ type: RTLNEWS_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchRTLWeather() {
    const language = yield select(getLanguage);

    let lang = language;
    if (lang === 'de') lang = 'lu';

    let baseUrl = 'https://api-gw.rtl.lu/niche-guardian/v1';

    try {
        const json = yield fetch(
            `${baseUrl}/meteo`
        ).then((response) => response.json());
        yield put({ type: RTLWEATHER_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchRTLSDG() {
    const language = yield select(getLanguage);

    let lang = language;
    if (lang === 'de') lang = 'lu';

    let baseUrl = 'https://api-gw.rtl.lu/niche-guardian/v1';

    try {
        const json = yield fetch(
            `${baseUrl}/sdg`
        ).then((response) => response.json());
        yield put({ type: RTLSDG_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchFetchBannerAlert() {
    const customer = yield select(getCustomer);
    const language = yield select(getLanguage);
    let apiUrl = getApiUrl(customer);

    try {
        const json = yield fetch(
            `${apiUrl}/banner?customer=${customer}&language=${language}`
        ).then((response) => response.json());
        yield put({ type: ALERT_RECEIVED, json: json });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchSlowData() {
    while (true) {
        try {
            yield all([
                fork(watchFetchActivities),
                fork(watchFetchOpeningHours),
                fork(watchFetchRestaurant),
                fork(watchFetchPoi),
                fork(watchFetchPoiHelperknapp),
                fork(watchFetchIMXPoi),
                fork(watchFetchWhatToDo),
                fork(watchFetchPoll),
                fork(watchFetchSDG),
                fork(watchFetchRTLSDG),
            ]);
        } catch (e) {
            console.error("Standard Data Error:", e);
        }
        yield delay(86400000); // 1 day
    }
}

function* watchStandardData() {
    while (true) {
        try {
            yield all([
                fork(watchFetchNews),
                fork(watchFetchEventsToday),
                fork(watchFetchJobs),
                fork(watchFetchRadar),
                fork(watchFetchRTLNews),
                fork(watchFetchVB),
                fork(watchFetchMeteo),
                fork(watchFetchVideoads),
                fork(watchFetchAds),
                fork(watchFetchRTLWeather),
                fork(watchFetchBus),
                fork(watchFetchTrains),
          //      fork(watchFetchTrafic),
          //      fork(watchFetchBannerAlert),
            ]);
        } catch (e) {
            console.error("Standard Data Error:", e);
        }
        yield delay(14400000); // 4 hours
    }
}
function* watchMediaPlayerData() {
    while (true) {
        try {
            yield all([
                fork(watchFetchVideoads),
            ]);
        } catch (e) {
            console.error("Standard Data Error:", e);
        }
        yield delay(3600000); // 1 hour
    }
}
function* watchReiderData() {
    while (true) {
        try {
            yield all([
                fork(watchFetchEreider),
            ]);
        } catch (e) {
            console.error("Standard Data Error:", e);
        }
        yield delay(3600000); // 1 hour
    }
}

function* watchFastData() {
    while (true) {
        try {
            yield all([
                fork(watchFetchBikes),
                fork(watchFetchParking),
            ]);
        } catch (e) {
            console.error("Fast Data Error:", e);
        }
        yield delay(300000); // 5 minutes
    }
}

function* fetchData() {
    const customer = yield select(getCustomer);
    const layout = yield select(getLayout);
    if (layout === 6) {
        yield all([
            fork(watchMediaPlayerData),
        ]);
    }
    else if (layout === 5) {
        yield all([
            fork(watchFetchAds),
        ]);
    }
    else {
        yield all([
            fork(watchSlowData),
            fork(watchStandardData),
            fork(watchReiderData),
            fork(watchFastData)
        ]);
    }
}

export default function* fetchDataWatcher() {
    while (true) {
        yield take(POLL_START);
        yield race([call(fetchData), take(POLL_STOP)]);
    }
}
